import { Add, Delete, Edit } from "@material-ui/icons";
import {
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Divider as MuiDivider,
  Typography,
  makeStyles,
} from "@material-ui/core";
import {
  deletePortAuthority,
  fetchPortAuthorities,
} from "../../../services/portAuthoritiesService";
import { useMutation, useQuery } from "react-query";

import CreateDialog from "./CreateDialog";
import CustomAlert from "../../components/CustomAlert";
import CustomTable from "../../components/Table";
import DeleteDialog from "../../components/CustomDeleteDialog";
import { Helmet } from "react-helmet-async";
import { NavLink } from "react-router-dom";
import UpdateDialog from "./UpdateDialog";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import useLocale from "../../../hooks/useLocale";
import { useState } from "react";

const Divider = styled(MuiDivider)(spacing);
const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const useStyles = makeStyles((theme) => {
  const map = Array.from(Array(10).keys()).reduce((map, i) => {
    map[`& .MuiTable-root .MuiTableRow-root[level="${i + 1}"]>td`] = {
      paddingLeft: theme.spacing(2 + 4 * (i + 1)),
    };
    return map;
  }, {});

  return {
    table: {
      ...map,
    },
    root: {
      margin: "0 0 20px 0",
    },
  };
});

const PortAuthorities = () => {
  const classes = useStyles();
  const { t } = useLocale();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isUpdateDialogOpen, setIsUpdateDialogOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [deleteError, setDeleteError] = useState("");
  const { data, isError, isLoading, refetch } = useQuery(
    "portAuthorities",
    fetchPortAuthorities
  );

  return (
    <>
      <Helmet title={t("Port Authorities")} />
      <Typography variant="h3" gutterBottom display="inline">
        {t("Port Authorities")}
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/">
          {t("Dashboard")}
        </Link>
        <Link component={NavLink} exact to="/parameters">
          {t("Parameters")}
        </Link>
        <Typography>{t("Port Authorities")}</Typography>
      </Breadcrumbs>

      <Divider my={6} />

      <CustomAlert
        open={isError}
        close={() => {
          refetch();
        }}
        message={t("A network error occured, please try again later")}
      />
      <div className={classes.table}>
        <CustomTable
          isLoading={isLoading}
          columns={[
            {
              title: t("Code"),
              field: "cd",
              width: "50px",
            },
            {
              title: t("Description"),
              field: "dscr",
            },
            {
              title: t("Parent Port Authority"),
              field: "parentDscr",
            },
            {
              title: t("Address"),
              field: "address",
            },
            {
              title: t("Email Address"),
              field: "email",
            },
            {
              title: t("Phone Number"),
              field: "phone",
            },
          ]}
          data={data}
          parentChildData={(row, rows) => rows.find(a => a.id === row.parent_id)}

          actions={[
            {
              icon: () => <Add />,
              tooltip: t("Add"),
              isFreeAction: true,
              onClick: () => {
                setIsCreateDialogOpen(true);
              },
            },
            {
              icon: () => <Edit htmlColor="#1E90FF" />,
              tooltip: t("Edit"),
              onClick: (event, rowData) => {
                setIsUpdateDialogOpen(true);
                setSelectedItem(rowData);
              },
            },
            {
              icon: () => <Delete htmlColor="#B22222" />,
              tooltip: t("Delete"),
              onClick: (event, rowData) => {
                setIsDeleteDialogOpen(true);
                setSelectedItem(rowData);
              },
            },
          ]}
        />
      </div>
      <CreateDialog
        open={isCreateDialogOpen}
        close={() => setIsCreateDialogOpen(false)}
        refetch={refetch}
      />

      <UpdateDialog
        open={isUpdateDialogOpen}
        close={() => setIsUpdateDialogOpen(false)}
        refetch={refetch}
        selectedItem={selectedItem}
      />
      <DeleteDialog
        title={t('Delete Port Authority')}
        message={t("Are you sure you want to delete the selected Port Authority")}
        fieldName="dscr"
        open={isDeleteDialogOpen}
        close={() => setIsDeleteDialogOpen(false)}
        refetch={refetch}
        selectedItem={selectedItem}
        deleteService={deletePortAuthority}
      />
    </>
  );
};

export default PortAuthorities;
